<template>
    <!-- Edit Diagnosis -->
    <div class="card" :class="{ 'teal lighten-5': !error, 'red lighten-5': error }" v-if="editDiagnosis">
        <div class="card-content">
            <div class="row">
                <form class="col s12">
                    <div class="row">
                        <div class="col s12">
                            <span class="card-title">Edit Diagnosis</span>
                        </div>

                        <div class="input-field col s12">
                            <input v-model="diagnosis" id="diagnosis" type="text" :disabled="isSubmitting" />
                            <label class="active" for="diagnosis">Diagnosis</label>
                        </div>

                        <div class="input-field col s12">
                            <a class="waves-effect waves-light btn black lighten-2 col s12 m2 left" :class="{ 'disabled': isSubmitting }"
                                @click.prevent="handleBack('clearDiagnosis')">
                                <i class="medium material-icons left">chevron_left</i>Back
                            </a>

                             <!-- Breaker -->
                            <span class="co1 m7"></span>

                            <button class="waves-effect waves-light btn col s12 m3 right"
                                :class="{ 'disabled': isSubmitting, 'teal': diagnosis }"
                                @click.prevent="handleDiagnosis">
                                <i class="medium material-icons left">sync</i>Confirm Edit
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>

    <!-- Add Authorization Item -->
    <div class="card add-auth-item-card" :class="{ 'teal lighten-5': !error, 'red lighten-5': error }" v-else>
        <div class="card-content">
            <div class="row">
                <form class="col s12">
                    <div class="row">
                        <div class="col s12" v-if="!isSubmitting">
                            <span class="card-title">Select Authorization Item
                                <span class="secondary-content tariff-card-actions">
                                    <button type="button" class="btn-flat tariff-card-icon-action tariff-preview-top-action"
                                        title="View tariff items" @click.prevent="handleTariffPreview" v-if="hasTariffs && !isTariffLoading">
                                        <i class="material-icons">visibility</i>
                                    </button>
                                    <i class="material-icons tariff-mini-spin grey-text" v-if="isTariffLoading">autorenew</i>
                                    <button type="button" class="btn-flat tariff-card-icon-action" title="Refresh tariff items"
                                        @click.prevent="handleTariffReload" v-else>
                                        <i class="material-icons">refresh</i>
                                    </button>
                                </span>
                            </span>
                        </div>
                        <div class="col s12" v-if="tariffMessage && !isTariffLoading">
                            <p class="tariff-card-message">{{ tariffMessage }}</p>
                        </div>
                        <div class="auth-item-fields-row">
                            <div class="input-field auth-item-field auth-item-field--item">
                                <TariffSearch :inputId="claimSearchInputId" :data="filterData" :startAgain="resetClaim"
                                    :startEdit="editClaim" :disabled="isSubmitting || isTariffLoading || !hasTariffs" @selected="handlePick"
                                    @searching="handleSearch" @clear="handleClear" />
                            </div>
                            <div class="input-field auth-item-field">
                                <input v-model="qty" @input="handlePricing" id="qty" type="number"
                                    :disabled="isSubmitting" />
                                <label class="active" for="qty">Quantity</label>
                            </div>
                            <div class="input-field auth-item-field">
                                <input v-model="amt" id="amt" type="number" readonly :disabled="isSubmitting" />
                                <label class="active" for="amt">Amount Charged</label>
                            </div>
                        </div>
                        <div class="input-field col s12 auth-item-actions">
                            <a class="waves-effect waves-light btn-large black lighten-2 col s12 m2 left" :class="{ 'disabled': isSubmitting }"
                                @click.prevent="handleBack('clearAuth')">
                                <i class="medium material-icons left">chevron_left</i>Back
                            </a>

                             <!-- Breaker -->
                            <span class="co1 m7"></span>

                            <button class="waves-effect waves-light btn-large col s12 m3 right"
                                :disabled="!canAuthorize"
                                :class="{ 'disabled': !canAuthorize, 'teal': canAuthorize }"
                                @click.prevent="handleAuth">
                                <i class="medium material-icons left">check_circle</i>Authorize Item
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>

    <Teleport to="body">
        <div class="tariff-preview-overlay" @click.self="handleTariffPreviewClose" v-if="isTariffPreviewOpen">
            <section :id="tariffModalId" class="tariff-preview-modal" role="dialog" aria-modal="true" aria-label="Authorization tariff items">
                <button type="button" class="tariff-preview-close" title="Close" @click.prevent="handleTariffPreviewClose">
                    <i class="material-icons">close</i>
                </button>
                <div class="tariff-preview-content">
                    <div class="tariff-preview-heading">
                        <span>Tariff directory</span>
                        <h5>Authorization Tariff Items</h5>
                        <p>Review the current approved items and rates.</p>
                    </div>
                    <div class="input-field tariff-preview-search">
                        <label class="active" :for="`${tariffModalId}-search`">Search tariff item</label>
                        <input v-model="tariffPreviewSearch" :id="`${tariffModalId}-search`" type="search"
                            placeholder="Search by item name" />
                    </div>
                    <div class="tariff-preview-list-meta" v-if="filteredTariffPreview.length">
                        <span>{{ tariffPreviewSearch ? "Matching items" : "Available items" }}</span>
                        <strong>{{ tariffPreviewStart }}–{{ tariffPreviewEnd }} of {{ filteredTariffPreview.length }}</strong>
                    </div>
                    <ul class="tariff-preview-list" v-if="filteredTariffPreview.length">
                        <li class="tariff-preview-list-item" v-for="tariff in paginatedTariffPreview" :key="`${tariff.item}-${tariff.price}`">
                            <span class="tariff-preview-item-name">{{ tariff.item }}</span>
                            <b class="tariff-preview-item-price">&#8358;{{ formatMoney(tariff.price) }}</b>
                        </li>
                    </ul>
                    <nav class="tariff-preview-pagination" aria-label="Tariff item pages" v-if="tariffPreviewTotalPages > 1">
                        <button type="button" :disabled="tariffPreviewPage === 1"
                            @click="handleTariffPreviewPage(tariffPreviewPage - 1)">
                            <i class="material-icons" aria-hidden="true">chevron_left</i>
                            <span>Previous</span>
                        </button>
                        <div class="tariff-preview-page-numbers">
                            <button type="button" v-for="page in tariffPreviewPageNumbers" :key="page"
                                :class="{ 'is-active': page === tariffPreviewPage }"
                                :aria-current="page === tariffPreviewPage ? 'page' : undefined"
                                :aria-label="`Page ${page}`" @click="handleTariffPreviewPage(page)">
                                {{ page }}
                            </button>
                        </div>
                        <button type="button" :disabled="tariffPreviewPage === tariffPreviewTotalPages"
                            @click="handleTariffPreviewPage(tariffPreviewPage + 1)">
                            <span>Next</span>
                            <i class="material-icons" aria-hidden="true">chevron_right</i>
                        </button>
                    </nav>
                    <p class="tariff-preview-empty" v-if="!filteredTariffPreview.length">No tariff item matches your search.</p>
                </div>
                <div class="tariff-preview-footer">
                    <button type="button" class="btn-flat" @click.prevent="handleTariffPreviewClose">Close</button>
                </div>
            </section>
        </div>
    </Teleport>
</template>

<script>
import { ref, onMounted, watch, computed } from "vue";
import getItems from "@/composables/getItems";
import TariffSearch from "@/components/search/TariffSearch.vue";
import { urlFormat } from "@/composables/tariff/urlFormat";
import { getCache, addCache, removeCache } from "@/composables/cache/cache";
import { capitalizeFirstLetter } from "@/composables/fxLibrary/coreFx.js";
import { siloMode } from '@/laravel/config';

export default {
    name: "AddAuthItemComponent",
    emits: ["update"],
    props: ["turl", "editDiagnosis", "reset"],
    components: { TariffSearch },
    setup(props, context) {
        const responseDefault = ref([]);
        const responseSearch = ref([]);
        const isSubmitting = ref(props.reset);
        const error = ref(false);
        const diagnosis = ref(props.editDiagnosis);
        const editClaim = ref(null);
        const resetClaim = ref(false);
        const selectedItem = ref(null);
        const selectedPrice = ref(null);
        const claim = ref(null);
        const qty = ref(null);
        const amt = ref(null);
        const claimSearchInputId = `authTariffItem-${Date.now()}-${Math.random().toString(16).slice(2)}`;
        const tariffUrl = ref(null);
        const isTariffLoading = ref(false);
        const tariffError = ref(null);
        const tariffLoaded = ref(false);
        const tariffPreviewSearch = ref("");
        const tariffPreviewPage = ref(1);
        const tariffPreviewPerPage = 100;
        const isTariffPreviewOpen = ref(false);
        const tariffModalId = `authTariffPreview-${Date.now()}-${Math.random().toString(16).slice(2)}`;
        const canAuthorize = computed(() => {
            return Boolean(selectedItem.value && qty.value && amt.value && !isSubmitting.value);
        });
        const hasTariffs = computed(() => responseDefault.value.length > 0);
        const tariffMessage = computed(() => {
            if (tariffError.value) {
                return tariffError.value;
            }
            if (tariffLoaded.value && !hasTariffs.value) {
                return "No tariff item is available for this scheme and provider.";
            }
            return null;
        });
        const filteredTariffPreview = computed(() => {
            const term = tariffPreviewSearch.value?.trim().toLowerCase();
            if (!term) {
                return responseDefault.value;
            }
            return responseDefault.value.filter(x => x.item?.toLowerCase().includes(term));
        });
        const tariffPreviewTotalPages = computed(() => {
            return Math.max(1, Math.ceil(filteredTariffPreview.value.length / tariffPreviewPerPage));
        });
        const paginatedTariffPreview = computed(() => {
            const start = (tariffPreviewPage.value - 1) * tariffPreviewPerPage;
            return filteredTariffPreview.value.slice(start, start + tariffPreviewPerPage);
        });
        const tariffPreviewStart = computed(() => {
            if (!filteredTariffPreview.value.length) {
                return 0;
            }
            return ((tariffPreviewPage.value - 1) * tariffPreviewPerPage) + 1;
        });
        const tariffPreviewEnd = computed(() => {
            return Math.min(tariffPreviewPage.value * tariffPreviewPerPage, filteredTariffPreview.value.length);
        });
        const tariffPreviewPageNumbers = computed(() => {
            const visiblePages = 5;
            const halfWindow = Math.floor(visiblePages / 2);
            let start = Math.max(1, tariffPreviewPage.value - halfWindow);
            const end = Math.min(tariffPreviewTotalPages.value, start + visiblePages - 1);
            start = Math.max(1, end - visiblePages + 1);

            return Array.from({ length: end - start + 1 }, (_, index) => start + index);
        });

        // data tariff
        const filterData = computed(() => {
            // start
            let val = {};

            let valPlus;

            if (responseSearch.value) {
                valPlus = responseSearch.value.reduce((newArr, x) => {
                    newArr[x.item] = null;
                    return newArr;
                }, {});
                val = { ...val, ...valPlus };
            }

            // return final
            return val;
        });
     
      // search function
      const getTariffFromApi = async (table, force = false) => {
      if (!table) {
        tariffError.value = "Unable to load tariff items for this scheme and provider.";
        tariffLoaded.value = true;
        return;
      }
      tariffUrl.value = table;
      tariffError.value = null;
      // get item from store (cache)
      let cacheTariff = getCache(table);
      // get from api
      if (cacheTariff?.length && !force) {
        responseDefault.value = cacheTariff;
        tariffLoaded.value = true;
      } else {
          isTariffLoading.value = true;
          const { res, err } = await getItems(table);
          if (res.value) {
            // search
            responseDefault.value = res.value.data || [];
            // add cache
            addCache(table, responseDefault.value);
          } else {
            tariffError.value = err.value || "Unable to load tariff items for this scheme and provider.";
          }
          tariffLoaded.value = true;
          isTariffLoading.value = false;
      }
    };

        // starter (set loading spin)
        onMounted(() => {
            if (!props.turl) {
                return;
            }
            // tariff url
            let url = urlFormat(props.turl); // to contain provider opid
            // modify if not silo mode
            if (!siloMode) {
                url = `source/${url}`; // using source for getting tariff from easyHMO (source)
            }
            getTariffFromApi(url);
        });

        const handleTariffReload = () => {
            if (!tariffUrl.value) {
                return;
            }
            removeCache(tariffUrl.value);
            getTariffFromApi(tariffUrl.value, true);
        };

        const handleTariffPreview = () => {
            tariffPreviewSearch.value = "";
            tariffPreviewPage.value = 1;
            isTariffPreviewOpen.value = true;
        };

        const handleTariffPreviewClose = () => {
            isTariffPreviewOpen.value = false;
        };

        const handleTariffPreviewPage = (page) => {
            tariffPreviewPage.value = Math.min(
                tariffPreviewTotalPages.value,
                Math.max(1, Number(page) || 1)
            );
        };

        const formatMoney = (val) => {
            return Number(val || 0)
                .toFixed(2)
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        };

        // update reset
        const updateSubmit = (val) => {
            if (val) {
                isSubmitting.value = false;
            }
        }

        // handle diagnosis
        const handleDiagnosis = () => {
            if (diagnosis.value) {
                // format for saving
                const { fx } = capitalizeFirstLetter(diagnosis.value);
                // send back
                context.emit("update", {
                    id: "resetDiagnosis",
                    value: fx.value,
                });

                // keep buttons and fields disabled
                isSubmitting.value = true;

                // reset error (if required)
                error.value = false;
            } else {
                error.value = true;
            }
        };

        // load claim
        const handleAuth = () => {
            // start action
            if (selectedItem.value && qty.value && amt.value) {
                // format for saving
                const { fx } = capitalizeFirstLetter(selectedItem.value);

                // send for auth
                context.emit("update", {
                    id: "addNewAuth",
                    value: {
                        id: Date.now(),
                        claim: fx.value,
                        qty: qty.value,
                        amt: amt.value,
                        standard: Number(selectedPrice.value).toFixed(2),
                    },
                });

                // keep buttons and fields disabled
                isSubmitting.value = true;

                // clear entry
                // claimInputClear();

                // reset error (if required)
                error.value = false;
            } else {
                error.value = true;
            }

        };

        // clear (back)
        const handleBack = (val) => {
            // clear
            context.emit("update", {
                id: val,
                value: true
            });
        }

        // watch qty & price
        const handlePricing = () => {
            amt.value = (Number(qty.value) * Number(selectedPrice.value)).toFixed(2);
        };

        // filter components
        const handleSearch = (val) => {
            if (val.item) {
                // sort new search
                responseSearch.value = responseDefault.value.filter((x) =>
                    x.item.toLowerCase().includes(val.item.toLowerCase())
                );
            } else {
                // empty search array
                responseSearch.value = [];

                // clear entry
                claimInputClear();
            }
        };

        // null reset
        const handleClear = (val) => {
            resetClaim.value = val.item;
            editClaim.value = val.item;
        };

        // get option
        const handlePick = (val) => {
            //set
            selectedItem.value = val.item;

            //set
            if (selectedItem.value) {
                // get the price out
                responseSearch.value.forEach((x) => {
                    if (x.item === selectedItem.value) {
                        // found
                        selectedPrice.value = x.price;
                    }
                });

                // set quantity & amount
                qty.value = 1;
                amt.value = (Number(qty.value) * Number(selectedPrice.value)).toFixed(
                    2
                );
            } else {
                // if null (very unlikely)
                // clear entry
                claimInputClear();
            }
        };

        // clear inputs
        const claimInputClear = () => {
            // clear all
            selectedItem.value = null;
            selectedPrice.value = null;
            resetClaim.value = true; // will clear claims input
            qty.value = null;
            amt.value = null;
            responseSearch.value = [];

            // clear error (if needed)
            error.value = false;
        };

        // watch for changes
        watch(props, (newVal) => {
            updateSubmit(newVal.reset);
        });

        watch(tariffPreviewSearch, () => {
            tariffPreviewPage.value = 1;
        });

        watch(tariffPreviewTotalPages, (totalPages) => {
            if (tariffPreviewPage.value > totalPages) {
                tariffPreviewPage.value = totalPages;
            }
        });

        return {
            handleDiagnosis,
            handleAuth,
            handleBack,
            handleTariffReload,
            handleTariffPreview,
            handleTariffPreviewClose,
            handleTariffPreviewPage,
            handlePricing,
            handleSearch,
            handleClear,
            handlePick,
            isSubmitting,
            canAuthorize,
            selectedItem,
            selectedPrice,
            responseSearch,
            editClaim,
            resetClaim,
            filterData,
            claimSearchInputId,
            filteredTariffPreview,
            paginatedTariffPreview,
            formatMoney,
            hasTariffs,
            isTariffLoading,
            isTariffPreviewOpen,
            tariffMessage,
            tariffModalId,
            tariffPreviewEnd,
            tariffPreviewPage,
            tariffPreviewPageNumbers,
            tariffPreviewSearch,
            tariffPreviewStart,
            tariffPreviewTotalPages,
            error,
            diagnosis,
            claim,
            qty,
            amt,
        };
    },
};
</script>

<style scoped>
.add-auth-item-card,
.add-auth-item-card .card-content,
.add-auth-item-card form,
.add-auth-item-card .row,
.add-auth-item-card .input-field {
    overflow: visible;
}

.add-auth-item-card {
    position: relative;
    z-index: 20;
}

.auth-item-fields-row {
    display: grid;
    gap: 1.25rem;
    grid-template-columns: minmax(0, 2fr) minmax(0, 1fr) minmax(0, 1fr);
    margin: 1.5rem 0 0;
}

.auth-item-field {
    display: flex;
    flex-direction: column;
    margin: 0;
    min-width: 0;
    padding: 0;
    position: relative;
}

.auth-item-field :deep(label) {
    color: var(--ui-foreground, #101828) !important;
    display: block;
    font-size: 0.8rem;
    font-weight: 600;
    line-height: 1.25;
    margin: 0 0 0.5rem;
    order: -1;
    position: static !important;
    transform: none !important;
    transform-origin: initial !important;
}

.auth-item-field :deep(input) {
    background: var(--ui-background, #ffffff) !important;
    border: 1px solid var(--ui-input, #d9e2e7) !important;
    border-radius: calc(var(--ui-radius, 8px) - 2px) !important;
    box-shadow: none !important;
    box-sizing: border-box;
    color: var(--ui-foreground, #101828);
    font-size: 0.95rem;
    height: 3rem !important;
    line-height: 3rem;
    margin: 0 !important;
    min-width: 0;
    padding: 0 0.875rem !important;
    width: 100% !important;
}

.auth-item-field :deep(input:focus) {
    border-color: var(--ui-ring, #607d8b) !important;
    box-shadow: 0 0 0 2px color-mix(in srgb, var(--ui-ring, #607d8b) 18%, transparent) !important;
}

.auth-item-field :deep(input:disabled),
.auth-item-field :deep(input[readonly]) {
    background: var(--ui-muted, #f4f7f9) !important;
    color: var(--ui-muted-foreground, #60758a);
}

.auth-item-actions {
    margin: 1.5rem 0 0;
    padding-left: 0 !important;
    padding-right: 0 !important;
}

.add-auth-item-card :deep(.autocomplete-content.dropdown-content) {
    max-height: 320px;
    overflow-y: auto;
    z-index: 1200;
}

.tariff-card-icon-action {
    height: 32px;
    line-height: 32px;
    padding: 0 6px;
}

.tariff-card-actions {
    align-items: center;
    display: inline-flex;
    gap: 4px;
}

.tariff-card-icon-action i,
.tariff-preview-top-action i,
.tariff-mini-spin {
    color: #607d8b;
}

.tariff-preview-top-action {
    background: #eceff1;
    border-radius: 16px;
}

.tariff-mini-spin {
    animation: tariff-spin 0.9s linear infinite;
    display: inline-block;
}

.tariff-card-message {
    background: #fff8e1;
    border-radius: 6px;
    color: #6d4c41;
    margin: 8px 0 0;
    padding: 10px 12px;
}

.tariff-preview-overlay {
    background: rgba(38, 50, 56, 0.48);
    bottom: 0;
    left: 0;
    position: fixed;
    right: 0;
    top: 0;
    z-index: 1200;
}

@media (max-width: 900px) {
    .auth-item-fields-row {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    .auth-item-field--item {
        grid-column: 1 / -1;
    }
}

@media (max-width: 600px) {
    .auth-item-fields-row {
        grid-template-columns: minmax(0, 1fr);
    }

    .auth-item-field--item {
        grid-column: auto;
    }
}

.tariff-preview-modal {
    background: #ffffff;
    border: 1px solid #cfcfcf;
    border-radius: 2px;
    box-shadow: 0 12px 30px rgba(0, 0, 0, 0.18);
    display: flex;
    flex-direction: column;
    font-family: Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
    height: min(820px, calc(100vh - 3rem));
    left: 50%;
    max-height: calc(100vh - 3rem);
    max-width: 880px;
    overflow: hidden;
    position: fixed;
    top: 50%;
    transform: translate(-50%, -50%);
    width: calc(100vw - 3rem);
    z-index: 1201;
}

.tariff-preview-content {
    display: flex;
    flex: 1 1 auto;
    flex-direction: column;
    min-height: 0;
    overflow: hidden;
    padding: 1.5rem 1.5rem 1rem;
}

.tariff-preview-heading {
    flex: 0 0 auto;
    padding-right: 3rem;
}

.tariff-preview-heading > span {
    color: #555555;
    display: block;
    font-family: inherit;
    font-size: 0.75rem;
    font-weight: 700;
    letter-spacing: 0.06em;
    margin-bottom: 0.35rem;
    text-transform: uppercase;
}

.tariff-preview-heading h5 {
    color: #111111;
    font-family: inherit;
    font-size: 1.35rem;
    font-weight: 700;
    line-height: 1.25;
    margin: 0;
}

.tariff-preview-heading p {
    color: #555555;
    font-family: inherit;
    font-size: 0.9rem;
    line-height: 1.45;
    margin: 0.4rem 0 0;
}

.tariff-preview-search {
    display: flex;
    flex: 0 0 auto;
    flex-direction: column;
    margin: 1.5rem 0 1.25rem;
}

.tariff-preview-search label {
    color: #111111 !important;
    display: block;
    font-family: inherit;
    font-size: 0.8rem;
    font-weight: 600;
    line-height: 1.25;
    margin: 0 0 0.5rem;
    order: -1;
    position: static !important;
    transform: none !important;
}

.tariff-preview-search input {
    background: #ffffff !important;
    border: 1px solid #bdbdbd !important;
    border-radius: 0 !important;
    box-shadow: none !important;
    box-sizing: border-box !important;
    color: #111111;
    font-family: inherit;
    font-size: 0.95rem !important;
    height: 2.6rem !important;
    margin: 0 !important;
    padding: 0 0.875rem !important;
    width: 100% !important;
}

.tariff-preview-search input:focus {
    border-color: #111111 !important;
    box-shadow: none !important;
}

.tariff-preview-list-meta {
    align-items: center;
    color: #444444;
    display: flex;
    flex: 0 0 auto;
    font-family: inherit;
    font-size: 0.78rem;
    font-weight: 600;
    justify-content: space-between;
    margin-bottom: 0.6rem;
}

.tariff-preview-list-meta strong {
    background: transparent;
    border-radius: 0;
    color: #111111;
    display: inline;
    min-height: 0;
    min-width: 0;
    padding: 0;
}

.tariff-preview-list {
    border: 1px solid #d5d5d5 !important;
    border-radius: 0;
    display: block !important;
    flex: 1 1 auto;
    list-style: none;
    margin: 0 !important;
    min-height: 8rem;
    overflow-x: hidden;
    overflow-y: auto !important;
    padding: 0 !important;
    visibility: visible !important;
}

.tariff-preview-list-item {
    align-items: center;
    background: #ffffff;
    border: 0 !important;
    border-bottom: 1px solid #e0e0e0 !important;
    display: flex;
    font-family: inherit;
    gap: 1rem;
    justify-content: space-between;
    min-height: 2.75rem;
    padding: 0.55rem 0.75rem !important;
    visibility: visible;
}

.tariff-preview-list-item:last-child {
    border-bottom: 0 !important;
}

.tariff-preview-list-item:hover {
    background: #f7f7f7;
}

.tariff-preview-item-name {
    color: #111111;
    font-size: 0.875rem;
    font-weight: 500;
    line-height: 1.3;
    min-width: 0;
}

.tariff-preview-item-price {
    background: transparent;
    border: 0;
    border-radius: 0;
    color: #111111;
    flex: 0 0 auto;
    font-size: 0.85rem;
    font-weight: 700;
    line-height: 1;
    padding: 0;
    position: static;
    text-align: right;
}

.tariff-preview-pagination {
    align-items: center;
    background: transparent;
    box-shadow: none;
    display: flex;
    flex: 0 0 auto;
    gap: 0.75rem;
    height: auto;
    justify-content: space-between;
    line-height: normal;
    margin-top: 1rem;
    min-height: 2.5rem;
    width: 100%;
}

.tariff-preview-pagination > button,
.tariff-preview-pagination > div > button {
    align-items: center;
    background: #ffffff;
    border: 1px solid #bdbdbd;
    border-radius: 0;
    color: #111111;
    cursor: pointer;
    display: inline-flex;
    font-family: inherit;
    font-size: 0.82rem;
    font-weight: 600;
    gap: 0.25rem;
    height: 2.5rem;
    justify-content: center;
    min-width: 2.5rem;
    padding: 0 0.75rem;
}

.tariff-preview-pagination > div {
    display: flex;
    gap: 0.35rem;
}

.tariff-preview-pagination > div > button {
    padding: 0;
}

.tariff-preview-pagination button:hover:not(:disabled),
.tariff-preview-pagination button:focus-visible {
    background: #f2f2f2;
    border-color: #111111;
}

.tariff-preview-pagination button[aria-current="page"] {
    background: #111111;
    border-color: #111111;
    color: #ffffff;
}

.tariff-preview-pagination button:disabled {
    cursor: not-allowed;
    opacity: 0.45;
}

.tariff-preview-pagination i {
    font-size: 1rem;
    line-height: 1;
}

.tariff-preview-empty {
    background: var(--ui-muted, #f4f7f9);
    border: 1px dashed var(--ui-border, #dbe4e8);
    border-radius: calc(var(--ui-radius, 8px) - 2px);
    color: var(--ui-muted-foreground, #60758a);
    font-family: inherit;
    margin: 0;
    padding: 2rem 1rem;
    text-align: center;
}

.tariff-preview-close {
    align-items: center;
    background: #ffffff;
    border: 1px solid #bdbdbd;
    border-radius: 0;
    color: #111111;
    cursor: pointer;
    display: inline-flex;
    height: 2.5rem;
    justify-content: center;
    position: absolute;
    right: 1.5rem;
    top: 1.5rem;
    width: 2.5rem;
}

.tariff-preview-close i {
    color: inherit;
    line-height: 1;
}

.tariff-preview-close:hover {
    background: #f2f2f2;
    color: #000000;
}

.tariff-preview-footer {
    border-top: 1px solid #d5d5d5;
    flex: 0 0 auto;
    padding: 0.75rem 1.5rem;
    text-align: right;
}

.tariff-preview-footer button {
    border: 1px solid #bdbdbd;
    border-radius: 0;
    color: #111111 !important;
    font-family: inherit;
    font-weight: 600;
    min-height: 2.5rem;
    padding: 0 1rem;
    text-transform: none;
}

.tariff-preview-footer button:hover {
    background: #f2f2f2;
}

@media only screen and (max-width: 600px) {
    .tariff-preview-modal {
        height: calc(100vh - 1.5rem);
        max-height: calc(100vh - 1.5rem);
        width: calc(100vw - 1.5rem);
    }

    .tariff-preview-content {
        padding: 24px 18px 16px;
    }

    .tariff-preview-list-item {
        align-items: flex-start;
        flex-direction: column;
        gap: 0.65rem;
    }

    .tariff-preview-footer {
        padding: 0.85rem 1.15rem;
    }

    .tariff-preview-pagination > button span {
        display: none;
    }
}

@keyframes tariff-spin {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
}
</style>
